import React, { useEffect, createElement } from 'react';
import { TopBanner } from './components/TopBanner';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { ProblemAgitation } from './components/ProblemAgitation';
import { Qualifier } from './components/Qualifier';
import { ProductReveal } from './components/ProductReveal';
import { BrandBlock } from './components/BrandBlock';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { ComparisonTable } from './components/ComparisonTable';
import { PlanComparison } from './components/PlanComparison';
import { ProKitBenefits } from './components/ProKitBenefits';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '931401796468747';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    // Official Meta Pixel base code
    const fbq: any = function (...args: any[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    w.fbq = fbq;
    w._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
    // Noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-brand-accent selection:text-white" data-id="element-0">
      <TopBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <Testimonials data-id="element-3" />
      <ProblemAgitation data-id="element-4" />
      <Qualifier data-id="element-5" />
      <ProductReveal data-id="element-6" />
      <BrandBlock data-id="element-7" />
      <Modules data-id="element-8" />
      <Bonuses data-id="element-9" />
      <ComparisonTable data-id="element-10" />
      <PlanComparison data-id="element-11" />
      <ProKitBenefits data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}